<div class="autocomplete-container">
    <label *ngIf="label" class="input-label" [for]="'inputElementRef-' + name">
        <span class="main-text">{{ label }}</span>
        <span>&nbsp;</span>
        <span class="text-gray-600">{{ labelSecondary }}</span>
    </label>
    <div class="autocomplete-input-group" #autocomplete>
        <input
            [formControl]="inputFormControl"
            #inputElementRef
            [id]="'inputElementRef-' + name"
            type="text"
            name="{{ name }}"
            placeholder="{{ placeholder }}"
            class="form-control box-input {{ 'alternative-style-' + appearance }}"
            [autocomplete]="'off'"
            [ngClass]="{
                'is-valid': inputFormControl.valid && inputFormControl.dirty && inputFormControl.value !== '',
                'is-invalid': inputFormControl.touched && !inputFormControl.valid
            }"
            [ngStyle]="{ 'text-transform': optionsTextTransform }"
            (focus)="handleInputFocus()"
            (keydown)="handleInputKeydown($event)"
            role="combobox"
            aria-autocomplete="list"
            [attr.aria-expanded]="isOptionsPanelVisible"
            [attr.aria-controls]="optionsListId"
            [attr.aria-activedescendant]="highlightedIndex >= 0 ? optionsListId + '-option-' + highlightedIndex : null"
        />
        <label
            class="autocomplete-input-group-append"
            [for]="'inputElementRef-' + name"
            [ngClass]="{
                disabled: disabled
            }"
            (click)="disabled ? null : handleArrowClick($event)"
        >
            <fa-icon class="input-group-text autocomplete-input-group-icon" [icon]="['fas', 'angle-down']" [ngClass]="{ 'icon-disabled': disabled }"></fa-icon>
        </label>
        <div *ngFor="let error of getErrorsMessages()" class="invalid-feedback">
            {{ error.message }}
        </div>
    </div>
    <!-- Panel in-flow (default): comportamiento actual para los usos que no portalean. -->
    <ng-container *ngIf="!panelInOverlay && isOptionsPanelVisible && filteredList.length > 0">
        <ng-container *ngTemplateOutlet="optionsTpl; context: { overlay: false }"></ng-container>
    </ng-container>

    <!-- Panel en CDK Overlay (opt-in via panelInOverlay): escapa el overflow/stacking del modal. -->
    <ng-template
        cdkConnectedOverlay
        [cdkConnectedOverlayOrigin]="autocomplete"
        [cdkConnectedOverlayOpen]="panelInOverlay && isOptionsPanelVisible && filteredList.length > 0"
        [cdkConnectedOverlayWidth]="autocomplete.offsetWidth"
        [cdkConnectedOverlayPositions]="overlayPositions"
    >
        <ng-container *ngTemplateOutlet="optionsTpl; context: { overlay: true }"></ng-container>
    </ng-template>
</div>

<ng-template #optionsTpl let-overlay="overlay">
    <ul class="options" [class.options--overlay]="overlay" role="listbox" [attr.id]="optionsListId">
        <li
            *ngFor="let option of filteredList | slice : 0 : 100; let i = index"
            (mousedown)="onOptionSelected(option)"
            role="option"
            [attr.id]="optionsListId + '-option-' + i"
            [attr.aria-selected]="i === highlightedIndex"
            [class.is-highlighted]="i === highlightedIndex"
        >
            <span [ngStyle]="{ 'text-transform': optionsTextTransform }">
                {{ option.label }}
            </span>
        </li>
    </ul>
</ng-template>
